import React from 'react'
import NavBar from './navbar'

export default props => (
    <header className='main-header'>
        <a href='/#/' className='logo'>
           <span className='logo-mini'><b>GB</b></span> 
           <span className='logo-lg'>
            <i className='fa fa-barcode'></i>  
            &nbsp;<b>Gestor de Boletos</b> 
            </span> 
        </a>
        <nav className='navbar navbar-static-top'>
            <a className='sidebar-toggle' data-toggle='offcanvas'></a>
            <NavBar/>
        </nav>

    </header>
)


// WEBPACK FOOTER //
// ./src/common/template/header.jsx